/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedExplainersRouteImport } from './routes/_authenticated/explainers'
import { Route as AuthenticatedAnnouncementsRouteImport } from './routes/_authenticated/announcements'
import { Route as AuthenticatedSplatRouteImport } from './routes/_authenticated/$'
import { Route as AuthenticatedOrganizationsRouteRouteImport } from './routes/_authenticated/organizations/route'
import { Route as AuthenticatedOrganizationsIndexRouteImport } from './routes/_authenticated/organizations/index'
import { Route as AuthenticatedOrganizationsIdRouteRouteImport } from './routes/_authenticated/organizations/$id/route'
import { Route as AuthenticatedOrganizationsIdIndexRouteImport } from './routes/_authenticated/organizations/$id/index'
import { Route as AuthenticatedOrganizationsIdCreditsIndexRouteImport } from './routes/_authenticated/organizations/$id/credits/index'
import { Route as AuthenticatedOrganizationsIdCreditsBillingPeriodsRouteImport } from './routes/_authenticated/organizations/$id/credits/billing-periods'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedExplainersRoute = AuthenticatedExplainersRouteImport.update({
  id: '/explainers',
  path: '/explainers',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedAnnouncementsRoute =
  AuthenticatedAnnouncementsRouteImport.update({
    id: '/announcements',
    path: '/announcements',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSplatRoute = AuthenticatedSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedOrganizationsRouteRoute =
  AuthenticatedOrganizationsRouteRouteImport.update({
    id: '/organizations',
    path: '/organizations',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOrganizationsIndexRoute =
  AuthenticatedOrganizationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationsRouteRoute,
  } as any)
const AuthenticatedOrganizationsIdRouteRoute =
  AuthenticatedOrganizationsIdRouteRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedOrganizationsRouteRoute,
  } as any)
const AuthenticatedOrganizationsIdIndexRoute =
  AuthenticatedOrganizationsIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedOrganizationsIdRouteRoute,
  } as any)
const AuthenticatedOrganizationsIdCreditsIndexRoute =
  AuthenticatedOrganizationsIdCreditsIndexRouteImport.update({
    id: '/credits/',
    path: '/credits/',
    getParentRoute: () => AuthenticatedOrganizationsIdRouteRoute,
  } as any)
const AuthenticatedOrganizationsIdCreditsBillingPeriodsRoute =
  AuthenticatedOrganizationsIdCreditsBillingPeriodsRouteImport.update({
    id: '/credits/billing-periods',
    path: '/credits/billing-periods',
    getParentRoute: () => AuthenticatedOrganizationsIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/login': typeof LoginRoute
  '/organizations': typeof AuthenticatedOrganizationsRouteRouteWithChildren
  '/$': typeof AuthenticatedSplatRoute
  '/announcements': typeof AuthenticatedAnnouncementsRoute
  '/explainers': typeof AuthenticatedExplainersRoute
  '/organizations/$id': typeof AuthenticatedOrganizationsIdRouteRouteWithChildren
  '/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/organizations/$id/': typeof AuthenticatedOrganizationsIdIndexRoute
  '/organizations/$id/credits/billing-periods': typeof AuthenticatedOrganizationsIdCreditsBillingPeriodsRoute
  '/organizations/$id/credits/': typeof AuthenticatedOrganizationsIdCreditsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/$': typeof AuthenticatedSplatRoute
  '/announcements': typeof AuthenticatedAnnouncementsRoute
  '/explainers': typeof AuthenticatedExplainersRoute
  '/': typeof AuthenticatedIndexRoute
  '/organizations': typeof AuthenticatedOrganizationsIndexRoute
  '/organizations/$id': typeof AuthenticatedOrganizationsIdIndexRoute
  '/organizations/$id/credits/billing-periods': typeof AuthenticatedOrganizationsIdCreditsBillingPeriodsRoute
  '/organizations/$id/credits': typeof AuthenticatedOrganizationsIdCreditsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/organizations': typeof AuthenticatedOrganizationsRouteRouteWithChildren
  '/_authenticated/$': typeof AuthenticatedSplatRoute
  '/_authenticated/announcements': typeof AuthenticatedAnnouncementsRoute
  '/_authenticated/explainers': typeof AuthenticatedExplainersRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/organizations/$id': typeof AuthenticatedOrganizationsIdRouteRouteWithChildren
  '/_authenticated/organizations/': typeof AuthenticatedOrganizationsIndexRoute
  '/_authenticated/organizations/$id/': typeof AuthenticatedOrganizationsIdIndexRoute
  '/_authenticated/organizations/$id/credits/billing-periods': typeof AuthenticatedOrganizationsIdCreditsBillingPeriodsRoute
  '/_authenticated/organizations/$id/credits/': typeof AuthenticatedOrganizationsIdCreditsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/organizations'
    | '/$'
    | '/announcements'
    | '/explainers'
    | '/organizations/$id'
    | '/organizations/'
    | '/organizations/$id/'
    | '/organizations/$id/credits/billing-periods'
    | '/organizations/$id/credits/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/$'
    | '/announcements'
    | '/explainers'
    | '/'
    | '/organizations'
    | '/organizations/$id'
    | '/organizations/$id/credits/billing-periods'
    | '/organizations/$id/credits'
  id:
    | '__root__'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/organizations'
    | '/_authenticated/$'
    | '/_authenticated/announcements'
    | '/_authenticated/explainers'
    | '/_authenticated/'
    | '/_authenticated/organizations/$id'
    | '/_authenticated/organizations/'
    | '/_authenticated/organizations/$id/'
    | '/_authenticated/organizations/$id/credits/billing-periods'
    | '/_authenticated/organizations/$id/credits/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/explainers': {
      id: '/_authenticated/explainers'
      path: '/explainers'
      fullPath: '/explainers'
      preLoaderRoute: typeof AuthenticatedExplainersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/announcements': {
      id: '/_authenticated/announcements'
      path: '/announcements'
      fullPath: '/announcements'
      preLoaderRoute: typeof AuthenticatedAnnouncementsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$': {
      id: '/_authenticated/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof AuthenticatedSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/organizations': {
      id: '/_authenticated/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AuthenticatedOrganizationsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/organizations/': {
      id: '/_authenticated/organizations/'
      path: '/'
      fullPath: '/organizations/'
      preLoaderRoute: typeof AuthenticatedOrganizationsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationsRouteRoute
    }
    '/_authenticated/organizations/$id': {
      id: '/_authenticated/organizations/$id'
      path: '/$id'
      fullPath: '/organizations/$id'
      preLoaderRoute: typeof AuthenticatedOrganizationsIdRouteRouteImport
      parentRoute: typeof AuthenticatedOrganizationsRouteRoute
    }
    '/_authenticated/organizations/$id/': {
      id: '/_authenticated/organizations/$id/'
      path: '/'
      fullPath: '/organizations/$id/'
      preLoaderRoute: typeof AuthenticatedOrganizationsIdIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationsIdRouteRoute
    }
    '/_authenticated/organizations/$id/credits/': {
      id: '/_authenticated/organizations/$id/credits/'
      path: '/credits'
      fullPath: '/organizations/$id/credits/'
      preLoaderRoute: typeof AuthenticatedOrganizationsIdCreditsIndexRouteImport
      parentRoute: typeof AuthenticatedOrganizationsIdRouteRoute
    }
    '/_authenticated/organizations/$id/credits/billing-periods': {
      id: '/_authenticated/organizations/$id/credits/billing-periods'
      path: '/credits/billing-periods'
      fullPath: '/organizations/$id/credits/billing-periods'
      preLoaderRoute: typeof AuthenticatedOrganizationsIdCreditsBillingPeriodsRouteImport
      parentRoute: typeof AuthenticatedOrganizationsIdRouteRoute
    }
  }
}

interface AuthenticatedOrganizationsIdRouteRouteChildren {
  AuthenticatedOrganizationsIdIndexRoute: typeof AuthenticatedOrganizationsIdIndexRoute
  AuthenticatedOrganizationsIdCreditsBillingPeriodsRoute: typeof AuthenticatedOrganizationsIdCreditsBillingPeriodsRoute
  AuthenticatedOrganizationsIdCreditsIndexRoute: typeof AuthenticatedOrganizationsIdCreditsIndexRoute
}

const AuthenticatedOrganizationsIdRouteRouteChildren: AuthenticatedOrganizationsIdRouteRouteChildren =
  {
    AuthenticatedOrganizationsIdIndexRoute:
      AuthenticatedOrganizationsIdIndexRoute,
    AuthenticatedOrganizationsIdCreditsBillingPeriodsRoute:
      AuthenticatedOrganizationsIdCreditsBillingPeriodsRoute,
    AuthenticatedOrganizationsIdCreditsIndexRoute:
      AuthenticatedOrganizationsIdCreditsIndexRoute,
  }

const AuthenticatedOrganizationsIdRouteRouteWithChildren =
  AuthenticatedOrganizationsIdRouteRoute._addFileChildren(
    AuthenticatedOrganizationsIdRouteRouteChildren,
  )

interface AuthenticatedOrganizationsRouteRouteChildren {
  AuthenticatedOrganizationsIdRouteRoute: typeof AuthenticatedOrganizationsIdRouteRouteWithChildren
  AuthenticatedOrganizationsIndexRoute: typeof AuthenticatedOrganizationsIndexRoute
}

const AuthenticatedOrganizationsRouteRouteChildren: AuthenticatedOrganizationsRouteRouteChildren =
  {
    AuthenticatedOrganizationsIdRouteRoute:
      AuthenticatedOrganizationsIdRouteRouteWithChildren,
    AuthenticatedOrganizationsIndexRoute: AuthenticatedOrganizationsIndexRoute,
  }

const AuthenticatedOrganizationsRouteRouteWithChildren =
  AuthenticatedOrganizationsRouteRoute._addFileChildren(
    AuthenticatedOrganizationsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedOrganizationsRouteRoute: typeof AuthenticatedOrganizationsRouteRouteWithChildren
  AuthenticatedSplatRoute: typeof AuthenticatedSplatRoute
  AuthenticatedAnnouncementsRoute: typeof AuthenticatedAnnouncementsRoute
  AuthenticatedExplainersRoute: typeof AuthenticatedExplainersRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedOrganizationsRouteRoute:
    AuthenticatedOrganizationsRouteRouteWithChildren,
  AuthenticatedSplatRoute: AuthenticatedSplatRoute,
  AuthenticatedAnnouncementsRoute: AuthenticatedAnnouncementsRoute,
  AuthenticatedExplainersRoute: AuthenticatedExplainersRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
